var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lifestyle / Music"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9266 3.45305V10.9864C13.9266 12.3064 12.8532 13.3797 11.5332 13.3797C10.2199 13.3797 9.13991 12.3064 9.13991 10.9864C9.13991 9.67305 10.2199 8.59972 11.5332 8.59972C12.0932 8.59972 12.5932 8.79305 12.9999 9.11305V5.14639L6.85991 6.89305V12.2731C6.85991 13.5931 5.77991 14.6664 4.46658 14.6664C3.14658 14.6664 2.07324 13.5931 2.07324 12.2731C2.07324 10.9597 3.14658 9.88639 4.46658 9.88639C5.01991 9.88639 5.51991 10.0797 5.92658 10.3931V4.49972C5.92658 3.51972 6.51991 2.75972 7.45991 2.50639L11.3132 1.45305C12.0932 1.23972 12.7532 1.31305 13.2199 1.67305C13.6932 2.02639 13.9266 2.62639 13.9266 3.45305Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicWhiteIcon);
export default __webpack_public_path__ + "static/media/MusicWhiteIcon.a6c0e21495262f6298039b303f473d68.svg";
export { ForwardRef as ReactComponent };